import { useAppStore } from '@/store/useAppStore.ts'
import { ExpressionInput } from 'calc-controls'

export function VoltageInput() {
  const voltage = useAppStore((s) => s.battery.voltage)
  const updateBattery = useAppStore((s) => s.updateBattery)

  return (
    <div className="voltage-input">
      <ExpressionInput
        label="Voltage"
        value={voltage || 0}
        onChange={(v) => updateBattery('voltage', v)}
        unit="V"
        min={0}
        decimals={2}
      />
    </div>
  )
}
